// Bildirim açma mantığı — TEK KAYNAK. Hem bildirim sayfası hem gelen-bildirim popup'ı
// bunu kullanır; ikisi birbirinden ayrışmasın (popup eskiden firma değiştirmiyor ve
// deeplink'i çevirmiyordu → başka firmadan gelen bildirime tıklayınca yanlış/boş sayfa).

// Eski/mobil-form deeplink'leri web route'una çevir (navigate birebir kullanır).
//   mobil-form : /approvals/MT/x                         → /sales/approvals/MT/x
//   query-form : /sales/approvals?doctype=MT&docnum=x     → /sales/approvals/MT/x
export function webDeeplink(dl) {
  if (!dl) return dl
  const qi = dl.indexOf('?')
  const path = qi >= 0 ? dl.slice(0, qi) : dl
  const qs = qi >= 0 ? new URLSearchParams(dl.slice(qi + 1)) : null
  const dt = qs?.get('doctype')
  const dn = qs?.get('docnum') || qs?.get('ordernum')
  if (dt && dn) {
    if (path === '/finance/approvals') return `/finance/approvals/${dt}/${dn}`
    if (path === '/sales/approvals' || path === '/approvals') return `/sales/approvals/${dt}/${dn}`
  }
  if (path.startsWith('/approvals/')) return `/sales${path}`  // mobil-form → web
  // Eski partner sipariş bildirimi Ayarlar'a gidiyordu; onay ekranı `/partners/orders`.
  if (path === '/settings/partners' && qs?.get('order')) {
    return `/partners/orders?order=${encodeURIComponent(qs.get('order'))}`
  }
  return dl
}

// Sohbet bildirimi mi ve hangi kanal? Deeplink biçimi: /chat/c/{id}?m={msgId}
// (chat_service.deeplink). Sohbet bildirimleri PANELDE açılır — kullanıcı bulunduğu
// sayfadan koparılmasın (kullanıcı isteği 18.08.2026). Belge kanalı bildirimleri
// belge sayfasına gider, panelde değil: orada bağlam belgenin kendisidir.
export function chatChannelFromNotification(item) {
  const dl = (item?.deeplink || '').trim()
  const m = dl.match(/^\/chat\/c\/(\d+)/)
  return m ? Number(m[1]) : null
}

// Deeplink'teki mesaj numarası (?m=…) — bildirime konu olan mesaj. Panel bunu
// kullanıp o mesaja kaydırır; yoksa kullanıcı akışın en altına düşer ve
// bildirimin hangi mesaj için geldiğini göremez.
// Konu kökü (?t=) — yanıt bildiriminde konunun kendisi. Sunucu yazar; arayüz
// bununla konu panelini açar, ?m= ile de yanıta kaydırır.
export function chatThreadFromNotification(item) {
  const dl = (item?.deeplink || '').trim()
  const qi = dl.indexOf('?')
  if (qi < 0) return null
  const t = new URLSearchParams(dl.slice(qi + 1)).get('t')
  return t && /^\d+$/.test(t) ? Number(t) : null
}

export function chatMessageFromNotification(item) {
  const dl = (item?.deeplink || '').trim()
  const qi = dl.indexOf('?')
  if (qi < 0) return null
  const m = new URLSearchParams(dl.slice(qi + 1)).get('m')
  return m && /^\d+$/.test(m) ? Number(m) : null
}

// Bildirimi aç: BAŞKA FİRMAYA aitse önce aktif firmayı ona çek (aksi halde hedef sayfa
// 01 filtresiyle açılıp kaydı bulamıyor), sonra çevrilmiş deeplink'e git.
export function openNotification(item, navigate, setActiveCompany, openChatChannel) {
  if (!item) return
  const comp = (item.company || '').trim()
  if ((comp === '01' || comp === '02') && typeof setActiveCompany === 'function') {
    setActiveCompany(comp)
  }
  // Sohbet bildirimi → yan panelde aç, sayfayı DEĞİŞTİRME.
  const chId = chatChannelFromNotification(item)
  if (chId) {
    const msgId = chatMessageFromNotification(item)
    // Konu yanıtında deeplink'teki mesaj KÖK mesajdır → paneli doğrudan konuda aç,
    // yoksa kullanıcı kanalı görür ama yanıtı bulamaz.
    // Konu kökü ÖNCE deeplink'ten okunur (?t=) — sunucu artık onu yazıyor.
    // Tipe bakan eski yol yedek: DM'de konuya yanıt 'chat.dm' tipiyle geliyor,
    // yalnız tipe güvenmek o durumda konuyu hiç açmıyordu.
    const threadRoot = chatThreadFromNotification(item)
    const isThread = threadRoot != null || String(item.type || '') === 'chat.thread_reply'
    // Panel yalnız geniş ekranda (lg) render edilir ve /chat'te zaten tam ekran var.
    // O iki durumda panele yönlendirmek "hiçbir şey olmadı" demektir → tam ekrana git.
    const wideScreen = typeof window !== 'undefined'
      && (window.matchMedia?.('(min-width: 1024px)')?.matches ?? true)
    const onChatPage = typeof window !== 'undefined'
      && String(window.location?.pathname || '').startsWith('/chat')
    if (typeof openChatChannel === 'function' && wideScreen && !onChatPage) {
      openChatChannel(chId, { messageId: msgId, threadId: threadRoot ?? (isThread ? msgId : null) })
      return
    }
    // Tam ekranda da konu bilgisini taşı: yanıt bildirimi kanalı açıp konuyu kapalı
    // bırakırsa kullanıcı yanıtı göremiyor (panel yolunda zaten taşınıyordu).
    const _t = threadRoot ?? (isThread ? msgId : null)
    const qs = msgId ? `?m=${msgId}${_t ? `&t=${_t}` : ''}` : ''
    navigate(`/chat/c/${chId}${qs}`)
    return
  }
  const link = webDeeplink((item.deeplink || '').trim()) || '/notifications'
  navigate(link)
}
